import { isSupported } from 'firebase/messaging';

import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import AdBlockDetected from '@oto-web/shared/components/global/AdBlockDetected';
import FirebaseNotifications from '@oto-web/shared/components/global/FirebaseNotifications';
import HorizontalScreenChecker from '@oto-web/shared/components/global/HorizontalScreenChecker';
import ModalManager from '@oto-web/shared/components/global/ModalManager';
import ToastManager from '@oto-web/shared/components/global/ToastManager';
import VideoPortal from '@oto-web/shared/components/global/VideoPortal';
import MapLoader from '@oto-web/shared/components/maps/MapLoader';
import ErrorBoundary from '@oto-web/shared/pages/Errors/ErrorBoundary';
import Router from '@oto-web/shared/router/Router';
import AppTheme from '@oto-web/shared/utils/AppTheme';
import AutoLoginChecker from '@oto-web/shared/utils/AutoLoginChecker';
import AxiosInterceptor from '@oto-web/shared/utils/AxiosInterceptor';
import FreshChatInitializer from '@oto-web/shared/utils/FreshChatInitializer';
import { ReduxProvider } from '@oto-web/shared/utils/configureStore';

const App = () => {
	const [isSupportedFirebaseNotifications, setIsSupportedFirebaseNotifications] = useState(false);

	useEffect(() => {
		isSupported().then((isSupported) => {
			setIsSupportedFirebaseNotifications(isSupported);
		});
	}, []);

	return (
		<BrowserRouter>
			<ReduxProvider>
				<AppTheme>
					<AxiosInterceptor>
						<ErrorBoundary>
							<AdBlockDetected />
							<ToastManager />
							<VideoPortal />
							<ModalManager />
							<MapLoader />
							{import.meta.env.VITE_INIT_FRESCHAT === 'true' && <FreshChatInitializer />}
							{isSupportedFirebaseNotifications && <FirebaseNotifications />}
							<HorizontalScreenChecker />
							<AutoLoginChecker>
								<Router />
							</AutoLoginChecker>
						</ErrorBoundary>
					</AxiosInterceptor>
				</AppTheme>
			</ReduxProvider>
		</BrowserRouter>
	);
};

export default App;
